import {ADMIN_PRODUCTS_ENDPOINT} from './../../constants/endpoints'
import axios from 'axios'
import { IProductOrderResource } from '../../modules/auth/models/ProductsModel'

export function getProduct(id?: number | string, isBarCode?: number, autoCreate: boolean = false) {
    const findByBarCode = isBarCode ?? 0;
    return axios.get<IProductOrderResource>(`${ADMIN_PRODUCTS_ENDPOINT}/${id}?is_bar_code=${findByBarCode}&auto_create=${autoCreate}`, {
        useLocal404Toast: true
    })
}
